// Time Format 

// utils/format.js
export const formatTimeWithoutSeconds = (time) => {
    if (!time) return "";
    try {
      return new Date(`1970-01-01T${time}`).toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      });
    } catch (e) {
      return time; // fallback
    }
  };
  